import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import NavBar from "@/components/NavBar";
import ApiStatusBanner from "@/components/ApiStatusBanner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import { AuthProvider } from "@/contexts/AuthContext";
import Dashboard from "@/pages/Dashboard";
import CompaniesList from "@/pages/CompaniesList";
import NewCompany from "@/pages/NewCompany";
import CompanyDetail from "@/pages/CompanyDetail";
import GenerateResolution from "@/pages/GenerateResolution";
import MultiGenerate from "@/pages/MultiGenerate";
import ResolutionsList from "@/pages/ResolutionsList";
import ResolutionDetail from "@/pages/ResolutionDetail";
import ComplianceCalendar from "@/pages/ComplianceCalendar";
import Procedures from "@/pages/Procedures";
import Notifications from "@/pages/Notifications";
import StyleLibrary from "@/pages/StyleLibrary";
import MeetingDetail from "@/pages/MeetingDetail";
import ImportCompanies from "@/pages/ImportCompanies";
import EditCompany from "@/pages/EditCompany";
import TeamSettings from "@/pages/TeamSettings";
import Vault from "@/pages/Vault";
import FyDocket from "@/pages/FyDocket";
import Registers from "@/pages/Registers";
import QuarterlyPack from "@/pages/QuarterlyPack";
import McaFormWizard from "@/pages/McaFormWizard";
import DscBook from "@/pages/DscBook";
import DocumentTemplates from "@/pages/DocumentTemplates";
import Schedule3Page from "@/pages/Schedule3";
import TallyIntegration from "@/pages/TallyIntegration";
import Efiling from "@/pages/Efiling";
import SuspendedBanner from "@/components/SuspendedBanner";
import Chat from "@/pages/Chat";
import SuperAdmin from "@/pages/SuperAdmin";
import Login from "@/pages/Login";
import PWAInstallButton from "@/pwa/PWAInstallButton";

function AppRoutes() {
  const location = useLocation();
  // Detect Emergent OAuth callback fragment synchronously (NOT inside useEffect)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <>
              <SuspendedBanner />
              <NavBar />
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/companies" element={<CompaniesList />} />
                <Route path="/companies/new" element={<NewCompany />} />
                <Route path="/companies/import" element={<ImportCompanies />} />
                <Route path="/companies/:id/edit" element={<EditCompany />} />
                <Route path="/companies/:id/fy-docket" element={<FyDocket />} />
                <Route path="/companies/:id/registers" element={<Registers />} />
                <Route path="/companies/:companyId/file/:formKey" element={<McaFormWizard />} />
                <Route path="/companies/:id" element={<CompanyDetail />} />
                <Route path="/generate" element={<GenerateResolution />} />
                <Route path="/generate/multi" element={<MultiGenerate />} />
                <Route path="/quarterly-pack" element={<QuarterlyPack />} />
                <Route path="/resolutions" element={<ResolutionsList />} />
                <Route path="/resolutions/:id" element={<ResolutionDetail />} />
                <Route path="/calendar" element={<ComplianceCalendar />} />
                <Route path="/dsc-book" element={<DscBook />} />
                <Route path="/templates" element={<DocumentTemplates />} />
                <Route path="/schedule3" element={<Schedule3Page />} />
                <Route path="/integrations/tally" element={<TallyIntegration />} />
                <Route path="/efiling" element={<Efiling />} />
                <Route path="/procedures" element={<Procedures />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/style-library" element={<StyleLibrary />} />
                <Route path="/meetings/:id" element={<MeetingDetail />} />
                <Route path="/vault" element={<Vault />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/chat/:sessionId" element={<Chat />} />
                <Route path="/settings/team" element={<TeamSettings />} />
                <Route path="/admin" element={<SuperAdmin />} />
              </Routes>
            </>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ApiStatusBanner />
          <AppRoutes />
          <PWAInstallButton />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
